module.exports = __webpack_public_path__ + "static/media/kevin-orlando.da15a4dd.jpg";